import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';
import { useArchetypeCalculation } from '@/hooks/useArchetypeCalculation';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import {
  Container,
  ScreenAboutLookStyles,
  Title,
  Subtitle,
} from './IdealMatchArchetypes.styles';

export const ScreenIdealMatchArchetypes: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'IdealMatchArchetypes',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { archetype } = useArchetypeCalculation();

  const form = useFormContext();
  const formName = form.watch('name');

  const handleNextStep = (): void => {
    preloadImage(archetype.successImage);
    preloadImage(archetype.paywallImage);
    wizard.nextStep();
  };

  const getBgImage = () => {
    return `${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`;
  };

  return (
    <ScreenAboutLookStyles
      background={'dark-solid'}
      bgImage={<img src={getBgImage()} alt="Chat Vibe" />}
    >
      <IonContent>
        <Container>
          <Subtitle variant={'body-large'} color={'neutral-white'}>
            {formName}, your ideal archetype match:
          </Subtitle>
          <Title variant={'title-medium'}>
            {archetype.title} {archetype.emoji}
          </Title>
          <UiTypography variant={'body-large'} align={'center'}>
            {archetype.description}
          </UiTypography>
        </Container>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        buttonText={'Unlock your full match now'}
      />
    </ScreenAboutLookStyles>
  );
};
